import React from "react";
import "./typography.css";

interface H5Props {
  text: string;
}
const H5: React.FC<H5Props> = ({ text }) => {
  return <h5 className="H5">{text}</h5>;
};

export default H5;
